import { FC } from 'react';

import { LinkExpired } from '../LinkExpired/LinkExpired';
import { BackgroundImage } from './Components/BackgroundImage/BackgroundImage';
import { WrapperContent } from './Components/WrapperContent/WrapperContent';

export const CallInvitationLinkExpiredPage: FC = () => {
  return (
    <>
      <BackgroundImage />
      <WrapperContent>
        <LinkExpired />
      </WrapperContent>
    </>
  );
};
